<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div [ngClass.xl]="'float-left'" [ngClass.sm]="'mb-075'" [ngClass.md]="'mb-075'">
          <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="paymentTermsFilter()" />
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
            <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
          </div>
          <a class="btn btn-outline-primary text-primary" (click)="modalOpen(modalPaymentTermsAdd, null)" *ngIf="_authenticationService.hasCapability('create_payment_terms')">{{ "ADD" | translate }}</a>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 50 : 150"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filteredPaymentTermsList"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" width="400" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CODE' | translate" prop="other.code" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.other.code }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'PAYMENT_TYPE' | translate" prop="other.payment_type_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.other.payment_type_name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DAYS_VALUE' | translate" prop="other.day_value" width="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.other.day_value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                <button class="bg-transparent border-0 text-secondary pr-1" (click)="modalOpen(modalPaymentTermsEdit, row)" *ngIf="_authenticationService.hasCapability('edit_payment_terms')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deletePaymentTerms(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_payment_terms')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" width="700" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile align-items-center">
                <div class="col-12">
                  <span class="font-weight-bold">{{ "NAME" | translate }}: </span>
                  <span>{{ row.name }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "CODE" | translate }}: </span>
                  <span>{{ row.other.code }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "DAYS_VALUE" | translate }}: </span>
                  <span>{{ row.other.day_value }}</span>
                </div>
                <div class="col-12 mt-075 text-right">
                  <div>
                    <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_payment_terms')" (click)="modalOpen(modalPaymentTermsEdit, row)">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </button>
                    <button (click)="deletePaymentTerms(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_payment_terms')">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>

<!-- Modal Edit -->
<ng-template #modalPaymentTermsEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "EDIT" | translate }} {{ "PAYMENT_TERM" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label [for]="'name'">{{ "PAYMENT_TERM" | translate }}<sup class="text-danger">*</sup></label>
        <input name="name" [(ngModel)]="paymentTerms.name" type="text" [id]="'name'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!paymentTerms.name || paymentTerms.name.length < 1 || paymentTerms.name.trim() === '')">{{ "ERRORS.INSERT_PAYMENT_TERMS" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label [for]="'code'">{{ "CODE" | translate }}</label>
        <input name="code" [(ngModel)]="paymentTerms.other.code" type="text" [id]="'code'" class="form-control" />
      </div>
      <div class="form-group col-12">
        <label [for]="'payment_type'">{{ "PAYMENT_TYPE" | translate }}</label>
        <ng-select [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" [items]="paymentTypes"
                   bindValue="value" bindLabel="label" [(ngModel)]="paymentTerms.other.payment_type"></ng-select>
      </div>
      <div class="form-group col-12">
        <label [for]="'day_value'">{{ "DAYS_VALUE" | translate }}<sup class="text-danger">*</sup></label>
        <input name="day_value" placeholder="Es. 1" [(ngModel)]="paymentTerms.other.day_value" type="number" [id]="'day_value'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!paymentTerms.other.day_value || paymentTerms.other.day_value < 1)">{{ "ERRORS.FIELD_DAY_VALUE_MIN" | translate }}</div>
        <div class="font-error" *ngIf="showModalError && paymentTerms.other.day_value > 365">{{ "ERRORS.FIELD_DAY_VALUE_MAX" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <div class="custom-control custom-control-primary custom-switch">
          <small class="mr-025">{{ "PAYMENT_END_MONTH" | translate }}</small>
          <input type="checkbox" class="custom-control-input" id="payment_end_month_edit" [(ngModel)]="paymentTerms.other.payment_end_month" />
          <label class="custom-control-label" for="payment_end_month_edit"> </label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="editPaymentTerms()">
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Edit -->

<!-- Modal Add -->
<ng-template #modalPaymentTermsAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ADD" | translate }} {{ "PAYMENT_TERM" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label [for]="'name'">{{ "PAYMENT_TERM" | translate }}<sup class="text-danger">*</sup></label>
        <input name="name" [(ngModel)]="paymentTerms.name" type="text" [id]="'name'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!paymentTerms.name || paymentTerms.name.length < 1 || paymentTerms.name.trim() === '')">{{ "ERRORS.INSERT_PAYMENT_TERMS" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label [for]="'code'">{{ "CODE" | translate }}</label>
        <input name="code" [(ngModel)]="paymentTerms.other.code" type="text" [id]="'code'" class="form-control" />
      </div>
      <div class="form-group col-12">
        <label [for]="'payment_type'">{{ "PAYMENT_TYPE" | translate }}</label>
        <ng-select [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" [items]="paymentTypes" [(ngModel)]="paymentTerms.other.payment_type"></ng-select>
      </div>
      <div class="form-group col-12">
        <label [for]="'day_value'">{{ "DAYS_VALUE" | translate }}<sup class="text-danger">*</sup></label>
        <input name="day_value" placeholder="Es. 1" [(ngModel)]="paymentTerms.other.day_value" type="number" [id]="'day_value'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!paymentTerms.other.day_value || paymentTerms.other.day_value < 1)">{{ "ERRORS.FIELD_DAY_VALUE_MIN" | translate }}</div>
        <div class="font-error" *ngIf="showModalError && paymentTerms.other.day_value > 365">{{ "ERRORS.FIELD_DAY_VALUE_MAX" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <div class="custom-control custom-control-primary custom-switch">
          <small class="mr-025">{{ "PAYMENT_END_MONTH" | translate }}</small>
          <input type="checkbox" class="custom-control-input" id="payment_end_month" [(ngModel)]="paymentTerms.other.payment_end_month" />
          <label class="custom-control-label" for="payment_end_month"> </label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="addPaymentTerms()">{{ "SEND" | translate }}/{{ "ERRORS.INSERT" | translate }}</button>
  </div>
</ng-template>
<!-- / Modal Add -->
